export enum TenantId {
  ETS = '0ba6e9b7-60b3-4fae-92f3-7e6ddd9e9b65',
  BRANDEIS = 'Brandeis',
  BRANDEIS_MOCK = 'Brandeis-Mock',
  CSU = 'CSU',
  CSU_MOCK = 'CSU-Mock',
  AU = 'AmericanUniversity',
  AU_MOCK = 'AmericanUniversity-Mock',
  DEFAULT = 'default',
}
